import { FirestoreDataConverter } from "@angular/fire/firestore";
import { PlanEnum } from "../enums/plan.enum";

/**
 * Organization class
 */
export class Organization {
  id: string;
  oid: string;
  administrators: string[];
  users: string[];
  supplierOfOrgIds: string[]; // List of organisations ids for which the user is a supplier
  plan: PlanEnum;
  main: boolean;
  plugins: string[];
  siret: string;
  siren: string;
  availableShops: number;

  constructor(organization?: Partial<Organization>) {
    this.id = organization?.id ?? '';
    this.oid = organization?.oid ?? '';
    this.administrators = organization?.administrators ?? [];
    this.users = organization?.users ?? [];
    this.supplierOfOrgIds = organization?.supplierOfOrgIds ?? [];
    this.plan = organization?.plan ?? PlanEnum.FREE;
    this.main = organization?.main ?? false;
    this.plugins = organization?.plugins ?? [];
    this.siren = organization?.siren ?? '';
    this.siret = organization?.siret ?? '';
    this.availableShops = organization?.availableShops ?? 1;
  }

  /**
   * Converter used to convert an organization from firebase
   */
  static converter: FirestoreDataConverter<Organization> = {
    toFirestore: (organization: Organization) => ({
      id: organization.id ,
      oid: organization.oid,
      administrators: organization.administrators,
      users: organization.users,
      supplierOfOrgIds: organization.supplierOfOrgIds,
      plan: organization.plan,
      main: organization.main,
      plugins: organization.plugins,
      siren: organization.siren,
      siret: organization.siret,
      availableShops: organization.availableShops,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new Organization({
        ...data,
        id: snapshot.id,
      });
    }
  }
}
